const styles = (theme) => ({
  customerWrapper: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
    },
  },
  avatarWrapper: {
    marginRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(2),
    },
  },
  avatar: {
    width: '4em',
    height: '4em',
    [theme.breakpoints.down('md')]: {
      width: '3.5em',
      height: '3.5em',
    },
    [theme.breakpoints.down('sm')]: {
      width: '2.5em',
      height: '2.5em',
    },
  },
  review: {
    marginBottom: '1em',
  },
  clampedReview: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 5,
    '-webkit-box-orient': 'vertical',
  },
});

export default styles;
